<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="500px"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        icon
        :ripple="false"
        class="no-background-hover"
        style="height:24px !important;width:24px !important"
        v-on="on"
      >
        <v-icon color="primary">
          mdi-pencil 
        </v-icon>
      </v-btn>
    </template>
    
    <material-card
      :offset="10"
      :full-width="true"
      color="hrissecondary"
      title="Socso Contribution"
      text="Update Socso Contribution"
      class="mb-0"
    >
      <v-container v-if="dialog">
        <v-row>
          <v-col
            cols="12"
            class="pb-0"
          >
            <v-autocomplete
              v-model="localSocsoContribution.contribution_category"
              :items="socsoContributionCategories"
              item-text="name"
              item-value="key"
              label="SOCSO Contribution Category"
              outlined
            />
          </v-col>

          <v-col
            cols="12"
            class="pb-0"
          >
            <v-menu
              v-model="startDateMenu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="290px"
              max-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="startDateDisplay"
                  v-validate="'required'"
                  :error-messages="errors.collect('startDateDisplay')"
                  data-vv-name="startDateDisplay"
                  data-vv-as="start date"
                  label="Start date"
                  readonly
                  outlined
                  class="label-position"
                  v-on="on"
                >
                  <template v-slot:prepend-inner>
                    <v-icon>
                      mdi-calendar
                    </v-icon>
                  </template>
                </v-text-field>
              </template>
              <v-date-picker
                v-model="localSocsoContribution.start_date"
                type="month"
                no-title
                :min="companyEmployeeStartDate"
                @input="startDateMenu = false"
              />
            </v-menu>
          </v-col>
        </v-row>
      </v-container>

      <v-card-actions>
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          class="px-10"
          @click="dialog = false"
        >
          Close
        </v-btn>
        <v-btn
          color="hrissecondary"    
          class="white--text px-10" 
          :loading="progressing"
          @click="submitForm"
        >
          Update
        </v-btn>
      </v-card-actions>
    </material-card>
  </v-dialog>
</template>

<script>
  export default {
    $_veeValidate: {
      validator: 'new', 
    },
    props: {
      socsoContribution: {
        type: Object,
        required: true,
      },
      companyEmployeeStartDate: {
        type: String,
        required: true,
      },
    },
    data () {
      return {
        dialog: false,
        progressing: false,
        localSocsoContribution: null,
        socsoContributionCategories: [
          { key: 0, name: 'No Contribution', description: 'No contribution for both employee and employer.' },
          { key: 1, name: 'First Category', description: 'All employees who have not reached the age of 60, must contribute under the First Category except for those who have attained 55 years of age and have no prior contributions before they reach 55 due to non-eligibility under the Employees’ Social Security Act, 1969' },
          { key: 2, name: 'Second Category', description: 'All employees who have reached the age of 60 must be covered under this category for the Employment Injury Scheme only.' },
        ],
        startDateMenu: false,
      }
    },
    computed: {
      startDateDisplay () {
        return this.localSocsoContribution.start_date ? this.$moment(this.localSocsoContribution.start_date + '-01', 'YYYY-MM-DD').format('MMM YYYY') : ''
      },
    },
    watch: {
      dialog: function (value) {
        if (!value) return
        this.localSocsoContribution = { ...this.socsoContribution }

        if (this.localSocsoContribution.contribution_category) { this.localSocsoContribution.contribution_category = parseInt(this.localSocsoContribution.contribution_category) }
        if (this.localSocsoContribution.start_date) { this.localSocsoContribution.start_date = this.localSocsoContribution.start_date.substring(0, 7) }
      },
    },
    methods: {
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return
            this.setProgressing(true)

            this.$api.companyEmployeeSocsoContributions().update(this.localSocsoContribution.id, this.prepareFormData())
              .then(res => {
                this.$snack({ message: res.data.status })
                this.$emit('updated')

                this.setProgressing(false)
                this.dialog = false
              })
          })
      },
      setProgressing (status) {
        this.progressing = status
      },
      prepareFormData () {
        if (this.localSocsoContribution.contribution_category === 0) {
          this.localSocsoContribution.is_employee_contributed = 0
          this.localSocsoContribution.is_employer_contributed = 0
        } else {
          this.localSocsoContribution.is_employee_contributed = 1
          this.localSocsoContribution.is_employer_contributed = 1
        }

        return {
          start_date: this.localSocsoContribution.start_date + '-01',
          is_employee_contributed: this.localSocsoContribution.is_employee_contributed,
          is_employer_contributed: this.localSocsoContribution.is_employer_contributed,
          contribution_category: this.localSocsoContribution.contribution_category,
        }
      },
    },
  }
</script>

<style scoped>
.no-background-hover::before {
  background-color: transparent !important;
}

.label-position >>> .v-label.v-label--active{
  margin-left:-28px;
  background:white;
  padding-right:5px
}
</style>
